import BasicRender from "./BasicRender";

/**
 *
 * Component renders a list of editable templates of type cartesian
 */
const CartesianRender = ({ cartesianTemplate, onRemove, isEditable }) => {
  return (
    <BasicRender
      datasetTemplate={cartesianTemplate}
      onRemove={onRemove}
      isEditable={isEditable}
    />
  );
};

export default CartesianRender;
